import { Button } from "@mui/material";
import withRole from "../../Hooks/withRole";
import { useEffect, useState } from "react";
import { Vocabulary } from "../../Utils/Vocabulary";
import GenericModal from "../GenericModal";
import SellBookForm from "./SellBookForm";
import { getData } from "../../Services/getData";
import { endpoints } from "../../Utils/UrlEnum";
import { AxiosResponse } from "axios";
import { FormsIds } from "../../Utils/Constants";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import genericStyles from "../../Styles/genericStyles.module.css";

function SellBookButton(props: any) {
  const [open, setOpen] = useState(false);
  const [books, setBooks] = useState([]);
  const [clients, setClients] = useState(props?.clients || []);
  const userId = props?.restrictByWorkPoint
    ? localStorage.getItem("userId")
    : undefined;

  useEffect(() => {
    getBooks();
  }, []);

  const getBooks = () => {
    getData(`${endpoints.books}?userId=${userId}`).then(
      (res: AxiosResponse) => {
        if (res?.data?.length > 0) setBooks(res?.data);
      }
    );

    //get clients
    const shouldFetchClients =
      (!props.clients || props.clients.length === 0) && !props.clientId;

    if (shouldFetchClients) {
      console.log("Fetching clients for SellBookButton...");
      getData(`${endpoints.client.main}`).then((res: AxiosResponse) => {
        if (res?.data?.length > 0) setClients(res?.data);
      });
    }
  };

  /**
   *
   * @returns
   */
  return (
    <div>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => setOpen(true)}
        size="large"
        sx={{ color: "white" }}
        fullWidth
      >
        {Vocabulary.products}
      </Button>
      <GenericModal
        open={open}
        onClose={() => setOpen(false)}
        title={Vocabulary.sellBookFormTitle}
        className={genericStyles.largeModal}
        actions={
          <div className={genericStyles.editClientModalEditButton}>
            <Button
              color="error"
              variant="contained"
              onClick={() => setOpen(false)}
              startIcon={<CancelIcon />}
            >
              {Vocabulary.cancel}
            </Button>
            <Button
              variant="contained"
              type="submit"
              form={FormsIds.sellBookForm}
              color="success"
              startIcon={<SaveIcon />}
            >
              {Vocabulary.save}
            </Button>
          </div>
        }
      >
        <SellBookForm
          onClose={() => {
            setOpen(false);
            props?.onClose();
          }}
          selectedRow={null}
          books={books}
          clients={clients}
          restrictWorkPoints={props.restrictByWorkPoint}
          clientId={props.clientId}
          name="SellBookForm"
          paymentMethods={props?.paymentMethods}
        />
      </GenericModal>
    </div>
  );
}

export default withRole(SellBookButton);
